import React from 'react';
import { Twitter, Instagram, Youtube, Linkedin, Apple } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_autoposter-32/artifacts/j0h273d6_auto.png";

// Official store badges
const APP_STORE_BADGE = "https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83";
const PLAY_STORE_BADGE = "https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png";
const APP_STORE_URL = "https://apps.apple.com/app/id6762516648";
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.autopostr.app";

const Footer = () => {
  const footerLinks = {
    product: [
      { label: 'Features', href: '/#features' },
      { label: 'Pricing', href: '/pricing' },
      { label: 'How It Works', href: '/#how-it-works' },
      { label: 'FAQ', href: '/#faq' },
    ],
    company: [
      { label: 'About Us', href: '#' },
      { label: 'Blog', href: '#' },
      { label: 'Careers', href: '#' },
      { label: 'Contact', href: '#' },
    ],
    legal: [
      { label: 'Privacy Policy', href: '/privacy-policy' },
      { label: 'Data Deletion', href: '/data-deletion' },
      { label: 'Terms of Service', href: '/terms' },
    ],
  };

  const socialLinks = [
    { icon: Twitter, href: '#', label: 'Twitter' },
    { icon: Instagram, href: '#', label: 'Instagram' },
    { icon: Youtube, href: '#', label: 'YouTube' },
    { icon: Linkedin, href: '#', label: 'LinkedIn' },
  ];

  return (
    <footer className="bg-[#0a0a0a] border-t border-white/10">
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <img 
                src={LOGO_URL} 
                alt="AutoPostr" 
                className="h-8 w-auto invert"
              />
            </div>
            <p className="text-[#737373] mb-6 max-w-sm leading-relaxed">
              We are a Social Media Agency dedicated to solving every social media posting problem— so you can grow without the stress. Built for digital marketers, affiliate marketers, creators, and online businesses.
            </p>
            <div className="flex gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  aria-label={social.label}
                  className="w-10 h-10 rounded-full bg-white/5 hover:bg-white/10 flex items-center justify-center transition-colors duration-200 text-white/60 hover:text-white"
                >
                  <social.icon size={18} />
                </a>
              ))}
            </div>

            {/* Mobile App Download CTAs */}
            <div className="mt-8">
              <p className="text-white/80 text-sm font-semibold mb-3 flex items-center gap-2">
                <Apple size={16} />
                Get the AutoPostr app
              </p>
              <div className="flex flex-wrap items-center gap-3">
                <a
                  href={APP_STORE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-app-store-badge"
                  aria-label="Download on the App Store"
                  className="inline-block hover:opacity-80 transition-opacity"
                >
                  <img src={APP_STORE_BADGE} alt="Download on the App Store" className="h-11 w-auto" />
                </a>
                <a
                  href={PLAY_STORE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-play-store-badge"
                  aria-label="Get it on Google Play"
                  className="inline-block hover:opacity-80 transition-opacity"
                >
                  <img src={PLAY_STORE_BADGE} alt="Get it on Google Play" className="h-[60px] w-auto -my-2" />
                </a>
              </div>
              <p className="text-white/40 text-xs mt-2">Available on iOS — Android coming soon.</p>
            </div>
          </div>

          {/* Product Links */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Product</h4>
            <ul className="space-y-3">
              {footerLinks.product.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-[#737373] hover:text-white transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-[#737373] hover:text-white transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Legal</h4>
            <ul className="space-y-3">
              {footerLinks.legal.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-[#737373] hover:text-white transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#737373] text-sm">
            © {new Date().getFullYear()} AutoPostr. All rights reserved.
          </p>
          <p className="text-[#737373] text-sm">
            Made with care for creators worldwide.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
